import { stringify } from 'qs'

import { takeEvery, call, put } from 'redux-saga/effects'

import {
  updateGithubData,
  errorGithubData,
  GITHUB_DATA_GET,
} from 'actions/github'

function _getGithubData({ fetch }, logError) {
  return function*(action) {
    try {
      const queryString = stringify(
        { code: action.payload.code },
        { addQueryPrefix: true }
      )
      const githubEndpoint = `/signup-with/github${queryString}`

      const githubResult = yield call(fetch, githubEndpoint)
      yield put(
        updateGithubData({
          data: githubResult,
        })
      )
    } catch (err) {
      yield call(logError, err)

      yield put(
        errorGithubData({
          error: true,
        })
      )
    }
  }
}

export const Test = {
  _getGithubData,
}

// Watchers
// ---------------------------------------------------------------------------
export function* watchGetGithubData(api, error) {
  yield takeEvery(GITHUB_DATA_GET, _getGithubData(api, error))
}
